import { render, staticRenderFns } from "./TreeDataTableOrg.vue?vue&type=template&id=edfdc2d0&scoped=true&"
import script from "./TreeDataTableOrg.vue?vue&type=script&lang=js&"
export * from "./TreeDataTableOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfdc2d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
